import { useQuery } from "@apollo/client/react";

import { GET_BLUEPRINT } from "./gql";

const useBlueprint = (blueprintId?: string) => {
  return useQuery(GET_BLUEPRINT, {
    variables: {
      id: blueprintId!,
    },
    // APOLLO CLIENT UPDATE
    nextFetchPolicy: "cache-first",
  });
};

export default useBlueprint;
